import React, { useCallback } from 'react';
import { Inline } from '@atlaskit/primitives/compiled';
import { fireUIAnalytics, type UIAnalyticsEvent } from '@atlassian/jira-product-analytics-bridge';
import { defineMessages, useIntl } from '@atlassian/jira-intl';
import type { TabId } from './types.tsx';
import TabButton from './TabButton.tsx';

type TabContainerProps = {
	selected: TabId;
	onSetSelectedTab: (newSelectedTab: TabId) => void;
};

const messages = defineMessages({
	recommendedTabLabel: {
		id: 'home-project-recommendations.recommended-tab-label.non-final',
		defaultMessage: 'Recommended',
		description: 'Label for the recommended tab',
	},
	recentTabLabel: {
		id: 'home-project-recommendations.recent-tab-label.non-final',
		defaultMessage: 'Recent',
		description: 'Label for the recent tab',
	},
});

const TabContainer = ({ selected, onSetSelectedTab }: TabContainerProps): React.ReactElement => {
	const { formatMessage } = useIntl();

	const onTabClick = useCallback(
		(analyticsEvent: UIAnalyticsEvent, newSelectedTab: TabId) => {
			fireUIAnalytics(analyticsEvent, 'projectRecommendationsTab', {
				selectedTab: newSelectedTab,
			});
			onSetSelectedTab(newSelectedTab);
		},
		[onSetSelectedTab],
	);

	return (
		<Inline space="space.050" alignBlock="center" role="radiogroup">
			<TabButton
				id="recommended"
				name={formatMessage(messages.recommendedTabLabel)}
				selected={selected}
				onTabClick={onTabClick}
			/>
			<TabButton
				id="recent"
				name={formatMessage(messages.recentTabLabel)}
				selected={selected}
				onTabClick={onTabClick}
			/>
		</Inline>
	);
};

export default TabContainer;
